﻿<script>
    import { registerSubmit } from "../tealium";
	import model from "../stores/modelStore";
	import { isValid } from "../validation";

    import { endSurveyPageIndex, pageNumber, currentPage, pageList } from '../stores/pageStore';
	import PageSection from "../components/PageSection.svelte";
	import Form from "../components/Form.svelte";
	import FormRow from "../components/FormRow.svelte";
	import FormColumn from "../components/FormColumn.svelte";
	import NavigationButtons from "../components/NavigationButtons.svelte";

	import PersonalDetails from "./PersonalDetails.svelte";
	import GeneralInformation from "./GeneralInformation.svelte";
	import FundDetails from "./FundDetails.svelte";
	import MedicalDetails from "./MedicalDetails.svelte";
	import EducationDetails from "./EducationDetails.svelte";

	let disabled = true;
	let buttons = null;
	let { isConfirmation } = $$props;

	const handleSubmit = async (e) => {
		//e.preventDefault();
		buttons.blockNext();

		if (isValid()) {
			registerSubmit($model.Contact.EmailAddress,
				$model.Contact.PhoneNumber);

			$model.SurveyComplete = true;
			let response = await model.saveModelAsync();
			console.log(response);

			buttons.next();
		}

		buttons.unblock();
	};

	if ($pageNumber == $endSurveyPageIndex) {
		window.location.href = $pageList[0].routeId;
	} else {
		$pageNumber = ($currentPage ? $currentPage.pageIndex : 0);
	}

</script>

{#if $pageNumber == ($currentPage ? $currentPage.pageIndex : 0)}
<PageSection>
	<Form id="confirmation" on:submit={handleSubmit}>
		{#if isConfirmation}
			<h1>Confirmation</h1>
		{:else}
			<h1>Review</h1>
		{/if}

		<div class="pages">
			<PersonalDetails {disabled} />
			<GeneralInformation {disabled} />
			{#if !$model.GeneralInformationScreenOut}
				<FundDetails {disabled} />
				{#if !$model.FundDetailsScreenOut}
					<MedicalDetails {disabled} />
					<EducationDetails {disabled} />
				{/if}
			{/if}
		</div>

		{#if isConfirmation}
			<FormRow>
				<FormColumn class="last">
					<NavigationButtons bind:buttons />
				</FormColumn>
			</FormRow>
		{/if}
	</Form>
</PageSection>
{/if}

<style>
</style>
